import urlHelper from '../helpers/url'

const yaTiene = () => {
    console.log('Yatenia');
    if(window.UserClientLibs && window.UserClientLibs.RefreshAsync){
        window.UserClientLibs.RefreshAsync().finally(
            urlHelper.returnBack()
        );
    }
    else{
        urlHelper.returnBack();
    }
}

export default yaTiene;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/yaTiene.js